import { Component, OnInit } from '@angular/core';
import { IGiftRedeem } from '@app/gifts/models/gift-redeem.interface';
import { ISeoTagType } from '@app/shared/services/seo/seo-tag-type.enum';
import { SEOService } from '@app/shared/services/seo/seo.service';
import { ActivatedRoute } from '@angular/router';
import { GiftCodeAssignmentStatus } from '../models/gift-code-assignment-status.enum';

@Component({
  selector: 'app-gift-redeem',
  templateUrl: './gift-redeem.component.html',
  styleUrls: ['./gift-redeem.component.scss']
})
export class GiftRedeemComponent implements OnInit {

  giftRedeemInfo: IGiftRedeem;
  outOfCodes: boolean;
  copied: boolean;

  constructor(
    private route: ActivatedRoute,
    private seoService: SEOService
  ) {
    this.seoService.setSEO([
      {
        tagType: ISeoTagType.Title,
        i18nKey: 'GIFTS.REDEEM.META-TITLE'
      }
    ]);
  }

  ngOnInit(): void {
    this.giftRedeemInfo = this.route.snapshot.data.giftRedeem;
    this.outOfCodes = this.giftRedeemInfo?.giftCode?.giftCodeAssignmentStatus === GiftCodeAssignmentStatus.OutOfCodes;
  }

  copyGiftCode(): void {
    navigator.clipboard.writeText(this.giftRedeemInfo.giftCode.assignedGiftCode);
    this.copied = true;
  }

}
